@import './pk-spinner.variables';

@layer utilities {
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}

:host {
  font-family: var(--spinner--font);
}

.primary,
.secondary {
  ::slotted(*) {
    // Apply a proper display style in order for the vertical margins to have effect
    @apply inline-block;
  }
}

.primary {
  font-family: var(--spinner--primary-font);
}

.secondary {
  ::slotted(*) {
    // Apply a top margin on the secondary text if provided
    @apply mt-[var(--spinner--secondary-margin-t)];
  }
}

.loader {
  @apply h-[var(--spinner--size)] w-[var(--spinner--size)];

  &--spinner {
    @apply z-[110] box-border h-full w-full overflow-hidden rounded-full border-[calc(var(--spinner--size)_/_10)] border-l-[calc(var(--spinner--size)_/_10)];
    @apply border-solid border-[color:var(--spinner--color-base)] border-l-[color:var(--spinner--color)];

    animation: spinner 1.5s infinite linear;
  }
}

[part='text-wrapper'].landscape {
  .primary,
  .secondary {
    ::slotted(*) {
      @apply ml-m text-left;
    }
  }
}

[part='text-wrapper'].portrait {
  .primary {
    ::slotted(*) {
      @apply mt-m;
    }
  }
}

[part='content'].landscape {
  @apply flex-row;
}
